import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CgUpdatePopover = ({
  children,
  hasExceededLimit,
  message,
  position = 'top', // Default position is 'top'
}) => {
  const { t } = useTranslation('common');
  const resolvedMessage =
    message ?? t('common:freemium.limitReachedMessage', 'You have reached your limit');
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (isPopoverVisible) {
      setIsAnimating(true); // Start animating when the popover becomes visible

      timeoutId = setTimeout(() => {
        setIsAnimating(false); // Stop animation after 300ms
      }, 300); // The duration of the transition
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isPopoverVisible]);

  const handleButtonClick = (e) => {
    if (hasExceededLimit) {
      setTimeout(() => {
        setIsAnimating(false); // Stop animation after 300ms
      }, 200); // The duration of the transition
      setTimeout(() => {
        setPopoverVisible(true); // Show popover immediately
      }, 10); // The duration of the transition
    } else {
      closePopover();
    }
  };

  const closePopover = () => {
    setPopoverVisible(false); // Hide popover immediately
  };

  const getPopoverPosition = () => {
    switch (position) {
      case 'top':
        return { top: '-220%', left: '100%', transform: 'translateX(-100%)' };
      case 'bottom':
        return {
          bottom: '-120%',
          left: '100%',
          transform: 'translateX(-100%)',
        };
      case 'left':
        return { left: '-220%', top: '100%', transform: 'translateY(-100%)' };
      case 'right':
        return { right: '-220%', top: '100%', transform: 'translateY(-100%)' };
      default:
        return { top: '-220%', left: '100%', transform: 'translateX(-100%)' };
    }
  };

  return (
    <div className="relative inline-block">
      {React.cloneElement(children, {
        onClick: (event) => {
          if (typeof children?.props?.onClick === 'function') {
            children?.props?.onClick(event); // Call child's onClick first
          }
          handleButtonClick(event); // Then call parent's onClick
        },
      })}
      {hasExceededLimit && isPopoverVisible && (
        <div
          className={`absolute bg-orange-300 text-orange-600 text-sm p-2 px-4 rounded shadow-lg z-50 transition-opacity duration-200 ease-in-out whitespace-nowrap ${
            isAnimating ? 'opacity-0' : 'opacity-100'
          }`}
          style={getPopoverPosition()}
        >
          <button
            className="absolute top-1 right-2 text-orange-600 font-bold"
            onClick={closePopover}
          >
            ×
          </button>
          <p>
            {resolvedMessage}
            <a
              href="/upgrade"
              className="underline font-bold hover:text-gray-200 ml-1"
            >
              {t('common:freemium.upgradeYourPlan', 'Upgrade Your Plan')}
            </a>
            .
          </p>
        </div>
      )}
    </div>
  );
};

export default CgUpdatePopover;
